// Components
import { Calendar as FluentCalendar, useTheme } from "@fluentui/react";
// Styles
import { upSmallIconProps, downSmallIconProps } from "../../../icons/icons.styles";
import { getCalendarStyles, getCalendarDayStyles, getCalendarMonthStyles } from "./Calendar.styles";
// Utilities
import moment from "moment";
import * as React from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/** Icons for calendar navigation */ export const calendarNavigationIcons = {
    /** Icon for calendar navigation to previous view*/ leftNavigation: upSmallIconProps.iconName,
    /** Icon for calendar navigation to next view*/ rightNavigation: downSmallIconProps.iconName
};
/**
 * Calendar component from Fluent with our customizations
 */ export const Calendar = (props)=>{
    // Calendar Strings with locale support from moment
    const dateStrings = {
        goToToday: Strings.Calendar_CalendarPickerTodayLabel,
        nextMonthAriaLabel: Strings.Calendar_NextMonthAriaLabel,
        prevMonthAriaLabel: Strings.Calendar_PrevMonthAriaLabel,
        prevYearAriaLabel: Strings.Calendar_PrevYearAriaLabel,
        nextYearAriaLabel: Strings.Calendar_NextYearAriaLabel,
        prevYearRangeAriaLabel: Strings.Calendar_PrevYearRangeAriaLabel,
        nextYearRangeAriaLabel: Strings.Calendar_NextYearRangeAriaLabel,
        months: moment.months(),
        shortMonths: moment.monthsShort(),
        days: moment.weekdays(),
        shortDays: moment.weekdaysShort()
    };
    const theme = useTheme();
    return /*#__PURE__*/ React.createElement(FluentCalendar, {
        ...props,
        strings: dateStrings,
        firstDayOfWeek: moment.localeData().firstDayOfWeek(),
        styles: getCalendarStyles(theme),
        calendarDayProps: {
            ...props.calendarDayProps,
            styles: getCalendarDayStyles(theme),
            navigationIcons: calendarNavigationIcons
        },
        calendarMonthProps: {
            ...props.calendarMonthProps,
            styles: getCalendarMonthStyles(theme),
            navigationIcons: calendarNavigationIcons
        }
    });
};
